import React from "react";
import _ from "lodash";

import { TQuestionOption } from "../GatewayForm/types";
import { useField } from "formik";

import SelectionCard from "./SelectionCard";

type TRadioProps = {
  name: string;
  option: TQuestionOption;
  error?: boolean
};

const Radio: React.FC<TRadioProps> = ({ name, option, error }) => {
  const id = _.kebabCase(`${name}-${option.value}`);

  // Quick fix for rendering this component 
  // without Form context on Gutenberg editor
  let field:any = {}
  let isChecked = () => false
  let isFocused = false
  let setFocus = isChecked
  try {
    field = useField(name)[0];
    isChecked = () => {
      if (!field.value) {
        return false;
      }
      return field.value === option.value;
    };

    const focusState = React.useState(false);
    isFocused = focusState[0];
    setFocus = focusState[1];
  } catch (error) {}

  // const [field] = useField(name);
  // const id = _.kebabCase(`${name}-${option.value}`);
  // const [isFocused, setFocus] = React.useState(false);
  // const isChecked = () => {
  //   if (!field.value) {
  //     return false;
  //   }
  //   return field.value === option.value;
  // };

  return (
    <>
      <input
        type="radio"
        id={id}
        style={{ opacity: 0, position: "absolute" }}
        value={option.value}
        name={name}
        onChange={field.onChange}
        onBlur={(e) => {setFocus(false); field.onBlur(e);}}
        onFocus={() => {setFocus(true)}}
        checked={isChecked()}
      />
      <SelectionCard
      style={ isFocused ? {outline: '1px solid' , outlineColor: '#1e90fc'} : error ? {outline: '1px solid' , outlineColor: '#D82727'} : {}}
        checked={isChecked()}
        fieldId={id}
        text={option.label}
        secondaryText={option.note}
        variant="circle"
      />
    </>
  );
};

export default Radio;
